import React from 'react'
import { Row, Col } from 'reactstrap'
import { AdvanceSelectFormGroup } from '../_molecules/_index'

function LoginPersonalInputs({
  interestedArea,
  interestedSector,
  specificBenchmarks,
  specificFunds,
  specificIssues,
  interestedAreaSelected,
  interestedSectorSelected,
  specificBenchmarksSelected,
  specificFundsSelected,
  specificIssuesSelected,
  setInterestedAreaSelected,
  setInterestedSectorSelected,
  setSpecificBenchmarksSelected,
  setSpecificFundsSelected,
  setSpecificIssuesSelected
}) {
  return (
    <>
      <Row>
        <Col md={6}>
          <AdvanceSelectFormGroup
            labelText={'What areas are you interested in?'}
            labelColor={''}
            selectProps={{
              id: 'interest-area',
              className: 'select',
              options: interestedArea.map((item) => ({ value: item.id, label: item.value })),
              isMulti: 'isMulti',
              value: interestedAreaSelected,
              onChange: (e) => setInterestedAreaSelected(e)
            }}
          />
        </Col>
        <Col md={6}>
          <AdvanceSelectFormGroup
            labelText={'What sectors are you interested in?'}
            labelColor={''}
            selectProps={{
              id: 'interest-sector',
              className: 'select',
              options: interestedSector.map((item) => ({ value: item.id, label: item.value })),
              isMulti: 'isMulti',
              value: interestedSectorSelected,
              onChange: (e) => setInterestedSectorSelected(e)
            }}
          />
        </Col>
        <Col md={12}>
          <AdvanceSelectFormGroup
            labelText={'Are there any specific M&G Funds that you would like to track?'}
            labelColor={''}
            selectProps={{
              id: 'specific-benchmarks',
              className: 'select',
              options: specificBenchmarks.map((item) => ({ value: item.id, label: item.value })),
              isMulti: 'isMulti',
              value: specificBenchmarksSelected,
              onChange: (e) => setSpecificBenchmarksSelected(e)
            }}
          />
        </Col>
        <Col md={6}>
          <AdvanceSelectFormGroup
            labelText={'Are there any specific benchmarks that you are interested in?'}
            labelColor={''}
            selectProps={{
              id: 'specific-funds',
              className: 'select',
              options: specificFunds.map((item) => ({ value: item.id, label: item.value })),
              isMulti: 'isMulti',
              value: specificFundsSelected,
              onChange: (e) => setSpecificFundsSelected(e)
            }}
          />
        </Col>
        <Col md={6}>
          <AdvanceSelectFormGroup
            labelText={'Are there any specific issuers you’d like to follow?'}
            labelColor={''}
            selectProps={{
              id: 'specific-issues',
              className: 'select',
              options: specificIssues.map((item) => ({ value: item.id, label: item.value })),
              isMulti: 'isMulti',
              value: specificIssuesSelected,
              onChange: (e) => setSpecificIssuesSelected(e)
            }}
          />
        </Col>
      </Row>
    </>
  )
}

export default React.memo(LoginPersonalInputs)
